import React from 'react';
import {navigate} from 'gatsby';

//CORE COMPONENTS
import { ThemeProvider, styled } from '../../../../../components-core/packages/components-core/dist/theme-provider/index';
import {
    Container,
    ContainerWrap,
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../../../components-core/packages/components-core/dist/container/index';

import { Button, ButtonAppearance } from '../../../../../components-core/packages/components-core/dist/button';

import { IntegratorRoot } from '../../../../../components-core/packages/components-core/dist/integrator-root/index';
import { Text, TextAppearance, TextAlignment, TextColor } from '../../../../../components-core/packages/components-core/dist/text';
import { Breakpoints } from '../../../../../components-core/packages/components-core/dist/helpers';
import { AspectRatioContainer, AspectRatio } from '../../../../../components-core/packages/components-core/dist/aspect-ratio-container/index';
import { Image } from '../../../../../components-core/packages/components-core/dist/image/index';
import { FixedWidthContainer } from '../../../../../components-core/packages/components-core/dist/fixed-width-container/index';
import { BreakpointWrapper } from '../../../../../components-core/packages/components-core/dist/breakpoint-wrapper/index';
import { Link } from '../../../../../components-core/packages/components-core/dist/link/index';
import { TableHeader } from '../../../price-list/inner-components/table-header/TableHeader'
import PriceTable from '../../inner-components/price-table/PriceTable';
import OptionalAccordion from '../../../optional-accordion/OptionalAccordion'
import PriceCard from '../../inner-components/price-card/PriceCard';
//CUSTOM COMPONENTS
import { TopContainer } from '../../../../helpers/ComponentHelpers';
import amarok from '../../inner-components/horizontal-car-list/amarok.png';
import caddy from '../../inner-components/horizontal-car-list/caddy.png';
import crafter from '../../inner-components/horizontal-car-list/crafter.png';
import transporter from '../../inner-components/horizontal-car-list/transporter.png';
import amarokActive from '../../inner-components/horizontal-car-list/amarok-active.png';
import caddyActive from '../../inner-components/horizontal-car-list/caddy-active.png';
import transporterActive from '../../inner-components/horizontal-car-list/transporter-active.png'
import crafterActive from '../../inner-components/horizontal-car-list/crafter-active.png'
import Layout from '../../../layout';
import LayoutTwo from '../../../layouttwo'

/**
 * Yatay olarak kaydırma yapabilmemiz için VW Core-Components yeterli olmadığı için
 * kendi containerlarımızı yazmak durumundayız.
 */
const HorizontalScrollableContainer = styled.div`
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    align-items: center;
`;

const CarContainer = styled.div`
    flex: 0 0 auto;
    cursor: pointer;
`;

const SelectedLine = styled.div`
    width: 100%;
    height: 2px;
    background-color: #00437a;
    display: ${props => props.isSelected ? 'block' : 'none'};
`;


const TopContainerPrice = styled.div`
    width: 100vw;
    
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;



class HorizontalCarList extends React.Component {

    constructor() {
        super();
        this.state = {
            selectedIndex: 0,
            updatingPage:1,
        }
    }

    renderTitle() {
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;
        if(isMobile){
            return (
                <Container 
                    padding={padding4Dimensions} 
                    horizontalAlign={ContainerHorizontalAlignment.center}
                >
                    <h2><Text textAlign={TextAlignment.center} appearance={TextAppearance.headline0400}>
                        Fiyatlarımızı&nbsp;<br/>
                        <Text bold appearance={TextAppearance.headline0400} >
                        güncelliyoruz
                        </Text>
                    </Text></h2>
                </Container>
            )
        }else {
                return (
            <Container 
                padding={padding4Dimensions} 
                horizontalAlign={ContainerHorizontalAlignment.center}
            >
                <h2><Text textAlign={TextAlignment.center} appearance={TextAppearance.headline0400}>
                    Fiyatlarımızı&nbsp; 
                    <Text bold appearance={TextAppearance.headline0400} >
                    güncelliyoruz
                    </Text>
                </Text></h2>
            </Container>
        ) 
        }
   
    }

    renderDescription() {

        return (
            <Container 
                padding={padding4Dimensions} 
                horizontalAlign={ContainerHorizontalAlignment.center} 
            >
                <Text textAlign={TextAlignment.center} appearance={TextAppearance.copy0200}>
                    Bu sırada modellerimizi inceleyebilirsiniz.                    
                </Text>
            </Container>
        )
    }

    renderButton() {

        return (
            <Container 
                horizontalAlign={ContainerHorizontalAlignment.center}
                padding={{ left: globalPadding, right: globalPadding }}
            >
                <Button appearance={ButtonAppearance.Primary} onClick={() => navigate('https://ticariarac.vw.com.tr/modeller/')}>
                    <Text appearance={TextAppearance.copy0150} color={TextColor.inherit}  >
                        Modelleri İncele
                    </Text> 
                </Button>
            </Container>
        )
    }

    renderInnerContainer() {

        const mainContainerPadding = {
            top: ContainerPadding.dynamic0300,
            bottom: ContainerPadding.dynamic0300
        }

        return (
            <Container 
                padding={mainContainerPadding}
                horizontalAlign={ContainerHorizontalAlignment.center} 
            >
                <Container 
                    horizontalAlign={ContainerHorizontalAlignment.center}
                    stretchContent={true}
                    wrap={ContainerWrap.always}
                >
                    {this.renderTitle()}
                    {this.renderDescription()}
                    {this.renderButton()}
                </Container>
            </Container>
        )
    }

    renderCars() {
        const datasetLength = dummyArray.length;
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;


        if(isMobile) {
            return dummyArray.map((item, index) =>
                <CarContainer onClick={() => this.setState({ selectedIndex: index })}>
                <Container padding={carContainerPadding(index, datasetLength)}>
                    <FixedWidthContainer columns={fixedWidthContainerAppearance}>
                        <Container wrap={ContainerWrap.always} gutter={ContainerGutter.static200}>
                            {index === this.state.selectedIndex ? <Image width="64px" height="30px" src={item.activeImage}/> : <Image src={item.img} />}
                            <Container stretchContent={true} wrap={ContainerWrap.always}>
                            {(item.name === 'Transporter') ? <Text
                                    appearance={TextAppearance.copy0100}
                                    bold={true}
                                >
                                    <Link>{item.name}</Link>
                                </Text> :  <Text
                                    appearance={TextAppearance.copy0100}
                                    textAlign={TextAlignment.center}
                                    bold={true}
                                >
                                    <Link>{item.name}</Link>
                                </Text> } 
                                <SelectedLine isSelected={this.state.selectedIndex === index} />
                            </Container>
                        </Container>
                    </FixedWidthContainer>
                </Container>
            </CarContainer>
            )
        }else{
            return dummyArray.map((item, index) =>
            <CarContainer onClick={() => this.setState({ selectedIndex: index })}>
                <Container padding={carContainerPadding(index, datasetLength)}>
                    <FixedWidthContainer columns={fixedWidthContainerAppearance}>
                        <Container wrap={ContainerWrap.always} gutter={ContainerGutter.static200}>
                            {index === this.state.selectedIndex ? <Image src={item.activeImage}/> : <Image src={item.img} />}
                            <Container stretchContent={true} wrap={ContainerWrap.always}>
                                <Text
                                    appearance={TextAppearance.copy0150}
                                    textAlign={TextAlignment.center}
                                    bold={true}
                                >
                                    <Link>{item.name}</Link>
                                </Text>
                                <SelectedLine isSelected={this.state.selectedIndex === index} />
                            </Container>
                        </Container>
                    </FixedWidthContainer>
                </Container>
            </CarContainer>

        )
        }
       
    }

    render() {
        if(this.state.updatingPage){
            return(
                <LayoutTwo theme={'main'}>
                <div style={{marginTop:'100px'}}>

                <Container horizontalAlign={ContainerHorizontalAlignment.center} padding={ContainerPadding.static200}>
                <ThemeProvider theme={'main'}>
                <Container wrap={ContainerWrap.never} stretchContent={true}>
                    <TopContainerPrice>
                     {this.renderInnerContainer()}
                     </TopContainerPrice>
                    </Container>
                    </ThemeProvider>
                    </Container>
               </div>
                </LayoutTwo>
            )
        }else {
            return (
            <LayoutTwo theme={'main'}>
            <div style={{marginTop:'100px'}}>
            <Container horizontalAlign={ContainerHorizontalAlignment.center} padding={ContainerPadding.static200}>
            
                <ThemeProvider theme={'main'}>
                    <Container wrap={ContainerWrap.never} stretchContent={true}>
                        <BreakpointWrapper max={Breakpoints.b960}>
                            <HorizontalScrollableContainer>
                                {this.renderCars()}
                            </HorizontalScrollableContainer>
                        </BreakpointWrapper>

                        <BreakpointWrapper min={Breakpoints.b960}>
                            <Container horizontalAlign={ContainerHorizontalAlignment.center}>
                                {this.renderCars()}
                            </Container>
                        </BreakpointWrapper>
                    </Container>
                </ThemeProvider>
                {this.renderPriceList(this.state.selectedIndex)}
            </Container>
            </div>
            </LayoutTwo>
            
        )
        }
 
    }

    renderPriceText() {
        return (
            <Container horizontalAlign={ContainerHorizontalAlignment.center} padding={ContainerPadding.static200}
            ><Text
                appearance={TextAppearance.headline350}
                textAlign={TextAlignment.center}
            >Fiyat Listeleri</Text></Container>
        )
    }


    renderPriceList(selectedIndex) {
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;

        const caddyOptional = {
            title: 'Caddy Opsiyonlar',
            price: '0000',
            description: 'Kampanyalı anahtar teslim fiyatı',
            caddyOptionalDetails: [
                {
                    'title': 'Metalik Renk',
                    'description': '2.500 TL'
                },
            ]
        }

        const transporterOptional = {
            title: 'Transporter Opsiyonlar',
            price: '0000',
            description: 'Kampanyalı anahtar teslim fiyatı',
            transporterOptionalDetails: [
                {
                    'title': 'Metalik Renk',
                    'description': '3.750 TL'
                },
                {
                    'title': 'Otomatik Vites*',
                    'description': '24.000 TL'
                },
            ]
        }

        const amarokOptional = {
            title: 'Amarok Opsiyonlar',
            price: '0000',
            description: 'Kampanyalı anahtar teslim fiyatı',
            amarokOptionalDetails: [
                {
                    'title': 'Metalik Renk',
                    'description': '2.750 TL'
                },
                {
                    'title': 'Mekanik Diferansiyel Kilidi',
                    'description': '4.199 TL'
                },
            ]
        }

        const crafterOptional = {
            title: 'Crafter Opsiyonlar',
            price: '0000',
            description: 'Kampanyalı anahtar teslim fiyatı',
            crafterOptionalDetails: [
                {
                    'title': 'Metalik Renk',
                    'description': '7.800 TL'
                },
                {
                    'title': 'Otomatik Şanzıman',
                    'description': '11.500 TL'
                },
                {
                    'title': '4Motion(Panelvan)',
                    'description': '23.600 TL'
                },
                {
                    'title': 'Klimatik Klima(Panelvan)',
                    'description': '7.930 TL'
                },
                {
                    'title': 'Led Farlar(Panelvan)',
                    'description': '6.825 TL'
                },
                {
                    'title': 'Şerit Takip Sistemi',
                    'description': '2.955 TL'   
                },
                {
                    'title': 'OYA 3 Noktadan Gergili Emniyet Kemeri (16+1 Servis)',
                    'description': '3.080 TL'
                },
                {
                    'title': 'OYA 3 Noktadan Gergili Emniyet Kemeri (19+1 Servis)',
                    'description': '3.656 TL'
                },
            ]
        }

        const caddyModels = {
            title: 'Caddy Modeller',
            description: 'Anahtar ve Kampanyalı teslim fiyatları',
            caddyTrendLineModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '211.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '154.526 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '23.179 TL'
                },
                {
                    'title': 'KDV',
                    'description': '31.987 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.162 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            caddyTrendLineDSGModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '228.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '166.685 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '25.003 TL'
                },
                {
                    'title': 'KDV',
                    'description': '34.504 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.162 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            caddyComfortlineModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '228.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '166.685 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '25.003 TL'
                },
                {
                    'title': 'KDV',
                    'description': '34.504 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.162 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            caddyComfortlineDSGModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '244.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '178.476 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '26.771 TL'
                },
                {
                    'title': 'KDV',
                    'description': '36.945 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.162 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            caddyExclusiveModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '243.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '178.108 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '26.716 TL'
                },
                {
                    'title': 'KDV',
                    'description': '36.868 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.162 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            caddyExclusiveDSGModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '260.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '190.267 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '28.540 TL'
                },
                {
                    'title': 'KDV',
                    'description': '39.385 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.162 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],

            caddyMaxiVanModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '183.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '147.741 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '5.910 TL'
                },
                {
                    'title': 'KDV',
                    'description': '27.657 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.046 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            caddyMaxiVanDSGModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '195.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '157.520 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '6.301 TL'
                },
                {
                    'title': 'KDV',
                    'description': '29.488 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.046 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            trCityVanStandartSasiModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '253.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '239.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '174.791 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '26.219 TL'
                },
                {
                    'title': 'KDV',
                    'description': '36.182 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.162 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            trCityVanUzunSasiModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '269.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '254.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '185.845 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '27.877 TL'
                },
                {
                    'title': 'KDV',
                    'description': '38.470 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.162 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            trPanelVanStandartSasiModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '208.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '196.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '158.742 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '6.350 TL'
                },
                {
                    'title': 'KDV',
                    'description': '29.717 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.046 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            trPanelVanUzunSasiModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '214.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '202.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '163.631 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '6.545 TL'
                },
                {
                    'title': 'KDV',
                    'description': '30.632 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.046 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            trPanelVanUzunSasi150ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '229.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '216.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '175.039 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '7.002 TL'
                },
                {
                    'title': 'KDV',
                    'description': '32.767 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.046 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            trPikapTekKabinModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '210.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '198.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '159.964 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '6.399 TL'
                },
                {
                    'title': 'KDV',
                    'description': '29.945 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.046 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            trPikapCiftKabinModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '223.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '211.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '170.463 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '6.819 TL'
                },
                {
                    'title': 'KDV',
                    'description': '31.911 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.162 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            caraComfortLineUzunSasi150ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '361.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '341.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '250.389 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '37.558 TL'
                },
                {
                    'title': 'KDV',
                    'description': '51.831 TL'
                },
                {
                    'title': 'MTV',
                    'description': '576 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            caraComfortLineUzunSasi150DSGModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '382.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '361.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '265.496 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '39.824 TL'
                },
                {
                    'title': 'KDV',
                    'description': '54.958 TL'
                },
                {
                    'title': 'MTV',
                    'description': '576 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            caraHighlineUzunSasi199DSGModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '451.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '427.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '314.133 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '47.120 TL'
                },
                {
                    'title': 'KDV',
                    'description': '65.025 TL'
                },
                {
                    'title': 'MTV',
                    'description': '576 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            caraHighlineUzunSasi199DSG4MotionModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '511.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '486.400 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '355.897 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '53.385 TL'
                },
                {
                    'title': 'KDV',
                    'description': '73.671 TL'
                },
                {
                    'title': 'MTV',
                    'description': '2.802 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            crafterServis16ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '366.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '343.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '278.910 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '11.156 TL'
                },
                {
                    'title': 'KDV',
                    'description': '52.212 TL'
                },
                {
                    'title': 'MTV',
                    'description': '576 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            crafterServis19ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '377.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '355.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '287.565 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '11.503 TL'
                },
                {
                    'title': 'KDV',
                    'description': '53.832 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.454 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            crafterOkul16ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '394.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '371.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '301.726 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '12.069 TL'
                },
                {
                    'title': 'KDV',
                    'description': '56.483 TL'
                },
                {
                    'title': 'MTV',
                    'description': '576 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            crafterOkul19ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '405.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '382.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '309.974 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '12.399 TL'
                },
                {
                    'title': 'KDV',
                    'description': '58.027 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.454 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            crafterPanelVanMWBModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '235.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '219.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '177.077 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '7.083 TL'
                },
                {
                    'title': 'KDV',
                    'description': '33.149 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.046 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],

            crafterPanelVanLWBModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '244.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '227.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '183.596 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '7.344 TL'
                },
                {
                    'title': 'KDV',
                    'description': '34.369 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.046 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],

            amarokHighlineModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '400.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '321.043 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '12.842 TL'
                },
                {
                    'title': 'KDV',
                    'description': '60.099 TL'
                },
                {
                    'title': 'MTV',
                    'description': '5.371 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            amarokCanyonModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '416.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '334.089 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '13.364 TL'
                },
                {
                    'title': 'KDV',
                    'description': '62.542 TL'
                },
                {
                    'title': 'MTV',
                    'description': '5.860 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            crafterServis15ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '357.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '276.058 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '11.042 TL'
                },
                {
                    'title': 'KDV',
                    'description': '51.678 TL'
                },
                {
                    'title': 'MTV',
                    'description': '576 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            crafterOkul16LWBComfortline: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '385.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '298.874 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '11.955 TL'
                },
                {
                    'title': 'KDV',
                    'description': '55.949 TL'
                },
                {
                    'title': 'MTV',
                    'description': '576 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],

            amarokAventuraModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '519.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '418.020 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '16.721 TL'
                },
                {
                    'title': 'KDV',
                    'description': '78.253 TL'
                },
                {
                    'title': 'MTV',
                    'description': '5.860 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],

        }


        if (isMobile) {
            if (selectedIndex === 0) {
            
                return (
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always} padding={{ top: '10px' }}><br/> <br/>

                        <PriceCard data={caddyModels.caddyExclusiveModelsDetails} dataTwo={caddyModels.caddyExclusiveDSGModelsDetails} containerColor={'#1f4aa5'} carName={'Caddy Exclusive'} modelNameOne={'Caddy 2.0 TDI 102 PS Exclusive'} modelNameTwo={'Caddy 2.0 TDI 102 PS Exclusive DSG'} kafone={'243.500'} kaftwo={'260.000'} carImage={3} /><br />
                        <PriceCard data={caddyModels.caddyComfortlineModelsDetails} dataTwo={caddyModels.caddyComfortlineDSGModelsDetails} containerColor={'#bebebe'} carName={'Caddy Comfortline'} modelNameOne={'Caddy 2.0 TDI 102 PS Comfortline'} modelNameTwo={'Caddy 2.0 TDI 102 PS Comfortline DSG'} kafone={'228.000'} kaftwo={'244.000'} carImage={2}  /><br />
                        <PriceCard data={caddyModels.caddyTrendLineModelsDetails} dataTwo={caddyModels.caddyTrendLineDSGModelsDetails} containerColor={'#b99e8c'} carName={'Caddy Trendline'} modelNameOne={'Caddy 2.0 TDI 102 PS Trendline'} modelNameTwo={'Caddy 2.0 TDI 102 PS Trendline DSG'} kafone={'211.500'} kaftwo={'228.000'} carImage={1} /><br />
                        <PriceCard data={caddyModels.caddyMaxiVanModelsDetails} dataTwo={caddyModels.caddyMaxiVanDSGModelsDetails} containerColor={'#bebebe'} carName={'Caddy Maxi Van'} modelNameOne={'Caddy Maxi Van 2.0 TDI 102 PS'} modelNameTwo={'Caddy Maxi Van 2.0 TDI 102 PS DSG'} kafone={'183.000'} kaftwo={'195.000'} carImage={4} /><br />
                        <OptionalAccordion optional={caddyOptional.caddyOptionalDetails} />
                        {this.renderCaddyNotesTexts()}
                    </Container>

                )
            } else if (selectedIndex === 1) {
                return (
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always} padding={{ top: '10px' }}><br/><br/>

                        <PriceCard data={caddyModels.trCityVanStandartSasiModelsDetails} dataTwo={caddyModels.trCityVanUzunSasiModelsDetails} carName={'Transporter Kombi'} modelNameOne={'Transporter City Van (5+1)/Camlı Van (4+1) 2.0 TDI Standart Şasi 150PS '} modelNameTwo={'Transporter City Van (5+1)/Camlı Van (4+1) 2.0 TDI Uzun Şasi 150PS'} kafone={'239.000'} kaftwo={'254.000'} containerColor={'#a0a0a0'} carImage={5} /><br />
                        <PriceCard data={caddyModels.trPanelVanStandartSasiModelsDetails} dataTwo={caddyModels.trPanelVanUzunSasiModelsDetails} dataThree={caddyModels.trPanelVanUzunSasi150ModelsDetails} modelNameOne={'Transporter Panel Van 2.0 TDI (2+1) Standart Şasi 110PS'} modelNameTwo={'Transporter Panel Van 2.0 TDI (2+1) Uzun Şasi 110PS '} modelNameThree={'Transporter Panel Van 2.0 TDI (2+1) Uzun Şasi 150PS'} kafone={'196.500'} kaftwo={'202.500'} kafthree={'216.500'} carName={'Transporter Panel Van'} containerColor={'#bebebe'} carImage={6} /><br />
                        <PriceCard data={caddyModels.trPikapTekKabinModelsDetails} dataTwo={caddyModels.trPikapCiftKabinModelsDetails} modelNameOne={'Transporter Pikap 2.0 TDI (2+1) Uzun Şasi Tek Kabin 110PS'} modelNameTwo={'Transporter Pikap 2.0 TDI (5+1) Uzun Şasi Çift Kabin 110PS'} carName={'Transporter Pikap'} kafone={'198.000'} kaftwo={'211.000'} containerColor={'#bebebe'} carImage={7} /><br />
                        <OptionalAccordion optional={transporterOptional.transporterOptionalDetails} />
                        {this.renderTransporterTexts()}
                    </Container>

                )
            } else if (selectedIndex === 2) {
                return (
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always} padding={{ top: '10px' }}><br/><br/>
                        <PriceCard data={caddyModels.caraHighlineUzunSasi199DSGModelsDetails} dataTwo={caddyModels.caraHighlineUzunSasi199DSG4MotionModelsDetails} carName={'Caravelle Highline'} modelNameOne={'Yeni Caravelle Highline 2.0 TDI Uzun Şasi 199PS DSG'} modelNameTwo={'Yeni Caravelle Highline 2.0 TDI Uzun Şasi 199PS DSG 4Motion'} kafone={'427.500'} kaftwo={'486.400'} containerColor={'#990009'} carImage={9} /><br />
                        <PriceCard data={caddyModels.caraComfortLineUzunSasi150ModelsDetails} dataTwo={caddyModels.caraComfortLineUzunSasi150DSGModelsDetails} carName={'Caravelle Comfortline'} modelNameOne={'Caravelle Comfortline 2.0 TDI Uzun Şasi 150PS'} modelNameTwo={'Caravelle Comfortline 2.0 TDI Uzun Şasi 150PS DSG'} kafone={'341.000'} kaftwo={'361.500'} containerColor={'#327396'} carImage={8} /><br />
                        {this.renderCaravelleTexts()}
                    </Container>

                )
            } else if (selectedIndex === 3) {
                return (
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always} padding={{ top: '10px' }}><br/><br/>
                        <PriceCard data={caddyModels.amarokAventuraModelsDetails} carName={'Amarok Aventura'}  modelNameOne={'Amarok Aventura 3.0 V6 TDI 258 PS Otomatik'} kafone={'519.500'} containerColor={'#002048'} carImage={12} /><br />
                        <PriceCard data={caddyModels.amarokCanyonModelsDetails} carName={'Amarok Canyon'} modelNameOne={'Amarok Canyon 3.0 V6 TDI 204 PS Otomatik'} kafone={'416.500'} containerColor={'#bc7d41'} carImage={11} /><br />
                        <PriceCard data={caddyModels.amarokHighlineModelsDetails} carName={'Amarok Highline'} modelNameOne={'Amarok Highline 3.0 V6 TDI 204 PS Otomatik'} kafone={'400.000'} containerColor={'#7d848c'} carImage={10} /><br />
                        <OptionalAccordion optional={amarokOptional.amarokOptionalDetails} />
                        {this.renderAmarokTexts()}
                    </Container>

                )
            } else if (selectedIndex === 4) {
                return (
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always} padding={{ top: '10px' }}><br/><br/>

                        <PriceCard data={caddyModels.crafterServis16ModelsDetails} dataTwo={caddyModels.crafterServis19ModelsDetails} dataThree={caddyModels.crafterServis15ModelsDetails} modelNameThree={'Crafter Servis 2.0 TDI (15+1) LWB HR 140 PS Comfortline'} kafthree={'340.000'} kafone={'343.500'} kaftwo={'355.000'} carName={'Crafter Servis'} modelNameOne={'Crafter Servis 2.0 TDI (16+1) ELWB HR 177 PS Comfortline'} modelNameTwo={'Crafter Servis 2.0 TDI (19+1) ELWB HR 177 PS Comfortline'}  containerColor={'#91969d'} carImage={13} /><br />
                        <PriceCard data={caddyModels.crafterOkul16ModelsDetails} dataTwo={caddyModels.crafterOkul19ModelsDetails} dataThree={caddyModels.crafterOkul16LWBComfortline} containerColor={'#dedede'} kafone={'371.500'} kaftwo={'382.500'} kafthree={'368.000'} carName={'Crafter Okul'} modelNameOne={'Crafter Okul 2.0 TDI (16+1) ELWB HR 177 PS Comfortline'} modelNameTwo={'Crafter Okul 2.0 TDI (19+1) ELWB HR 177 PS Comfortline'}  modelNameThree={'Crafter Okul 2.0 TDI (16+1) LWB HR 140 PS Comfortline'} carImage={14} /><br />
                        <PriceCard data={caddyModels.crafterPanelVanMWBModelsDetails} dataTwo={caddyModels.crafterPanelVanLWBModelsDetails} modelNameOne={'Crafter Panel Van 2.0 TDI (2+1) MWB HR 140 PS 3,5 T Comfortline'} modelNameTwo={'Crafter Panel Van 2.0 TDI (2+1) LWB HR 140 PS 3,5 T Comfortline'} containerColor={'#bebebe'}  kafone={'219.000'} kaftwo={'227.000'} carName={'Crafter Panel Van'}  carImage={15} /><br />
                        <OptionalAccordion optional={crafterOptional.crafterOptionalDetails} />
                        {this.renderCrafterTexts()}
                    </Container>

                )
            }

        } else {

            if (selectedIndex === 0) {

                return (

                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always} marginTop={'100px'}><br /><br />
                       
                        <PriceTable selectedIndex={selectedIndex} carName={'Caddy Exclusive'} model={caddyModels.caddyExclusiveModelsDetails} modelTwo={caddyModels.caddyExclusiveDSGModelsDetails} carImage={3} /><br /><br />
                        <PriceTable selectedIndex={selectedIndex} carName={'Caddy Comfortline'} model={caddyModels.caddyComfortlineModelsDetails} modelTwo={caddyModels.caddyComfortlineDSGModelsDetails} carImage={2} /><br /><br />
                        <PriceTable selectedIndex={selectedIndex} carName={'Caddy Trendline'} model={caddyModels.caddyTrendLineModelsDetails} modelTwo={caddyModels.caddyTrendLineDSGModelsDetails} carImage={1} /><br /><br />
                        <PriceTable selectedIndex={selectedIndex} carName={'Caddy Maxi Van'} model={caddyModels.caddyMaxiVanModelsDetails} modelTwo={caddyModels.caddyMaxiVanDSGModelsDetails} carImage={4} /><br /><br />
                        <OptionalAccordion optional={caddyOptional.caddyOptionalDetails} />
                        {this.renderCaddyNotesTexts()}

                    </Container>
                )
            } else if (selectedIndex === 1) {

                return (
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always}><br /><br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.trCityVanStandartSasiModelsDetails} modelTwo={caddyModels.trCityVanUzunSasiModelsDetails} carName={'Transporter Kombi'} carImage={5} /><br /><br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.trPanelVanStandartSasiModelsDetails} modelTwo={caddyModels.trPanelVanUzunSasiModelsDetails} modelThree={caddyModels.trPanelVanUzunSasi150ModelsDetails} carName={'Transporter Panel Van'} carImage={6} /><br /><br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.trPikapTekKabinModelsDetails} modelTwo={caddyModels.trPikapCiftKabinModelsDetails} carName={'Transporter Pikap'} carImage={7} /><br /><br />
                        <OptionalAccordion optional={transporterOptional.transporterOptionalDetails} />
                        {this.renderTransporterTexts()}
                    </Container>)
            }
            else if (selectedIndex === 2) {
                return (<Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always}><br /><br />
                    <PriceTable selectedIndex={selectedIndex} model={caddyModels.caraHighlineUzunSasi199DSGModelsDetails} modelTwo={caddyModels.caraHighlineUzunSasi199DSG4MotionModelsDetails} carName={'Yeni Caravelle Highline'} carImage={9} /><br /><br />
                    <PriceTable selectedIndex={selectedIndex} model={caddyModels.caraComfortLineUzunSasi150ModelsDetails} modelTwo={caddyModels.caraComfortLineUzunSasi150DSGModelsDetails} carName={'Caravelle Comfortline'} carImage={8} /><br /><br />
                    {this.renderCaravelleTexts()}
                </Container>)
            }
            else if (selectedIndex === 3) {
            
                return (
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always}><br /><br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.amarokAventuraModelsDetails} carName={'Amarok Aventura'} carImage={12} /><br /><br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.amarokCanyonModelsDetails} carName={'Amarok Canyon'} carImage={11} /><br /><br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.amarokHighlineModelsDetails} carName={'Amarok Highline'} carImage={10} /><br /><br />
                        <OptionalAccordion optional={amarokOptional.amarokOptionalDetails} />
                        {this.renderAmarokTexts()}
                    </Container>)
            }
            else if (selectedIndex === 4) {

                return (
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always}><br /><br />

                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.crafterServis16ModelsDetails} modelTwo={caddyModels.crafterServis19ModelsDetails} modelThree={caddyModels.crafterServis15ModelsDetails} carName={'Crafter Servis'} carImage={13} /><br /><br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.crafterOkul16ModelsDetails} modelTwo={caddyModels.crafterOkul19ModelsDetails} modelThree={caddyModels.crafterOkul16LWBComfortline} carName={'Crafter Okul'} carImage={14} /><br /><br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.crafterPanelVanMWBModelsDetails} modelTwo={caddyModels.crafterPanelVanLWBModelsDetails} carName={'Crafter Panel Van'} carImage={15} /><br /><br />
                        <OptionalAccordion optional={crafterOptional.crafterOptionalDetails} />
                        {this.renderCrafterTexts()}
                    </Container>)
            }
        }


    }
    renderCaddyNotesTexts() {
        return (
            <Container stretchContent={true} padding={topContainerPadding}>
                <Text color={TextColor.secondary}><br/> <br/>1- Doğuş Otomotiv üretim, ithalat gibi nedenlere bağlı olarak aracın model, standart ve opsiyonel aksesuarlarında, teknik özelliklerinde ve fiyatlarında
önceden haber vermeksizin değişiklik yapma hakkını saklı tutar.<br/><br/></Text>
                <Text color={TextColor.secondary}>2- Bu fiyat listesindeki fiyatların uygulanmaya başladığı tarih 21.11.2020’dir. Tavsiye edilen bu anahtar teslim fiyat listesi yenisi yayınlanana kadar
geçerlidir. Listede belirtilen araçlar stoklarla sınırlıdır. Kesin sipariş verilmesi halinde ifa tarihinde yürürlükte olacak tavsiye edilen fiyat listesindeki
fiyatlar geçerli olacaktır. Bu nedenle, aracın tavsiye edilen anahtar teslim fiyatı değişebilecektir.<br/><br/></Text>
<Text color={TextColor.secondary}>3- Burada belirtilen fiyatlar, standart donanımlı araçlara ait olup, opsiyonel ekipmanlar ve renkler ayrıca fiyatlandırılır. <br/><br/></Text>
<Text color={TextColor.secondary}>4- Araca ilişkin her türlü vergi (ÖTV, KDV, MTV vb.), trafik tescil ve ruhsat işlemleri resmi bedelleri; resmi tarife değişikliklerine bağlı olarak
değişkenlik gösterebileceğinden, bu değişikliklerden kaynaklanabilecek fiyat farkı / farkları müşteri tarafından karşılanacaktır. Bununla birlikte resmi
tarife değişikliği olmaksızın vergi mevzuatından kaynaklı hesaplama yöntemleri nedeniyle vergi tutarlarında farklar oluşabilecektir. <br/><br/></Text>
<Text color={TextColor.secondary}>5- Menşei: Polonya <br/><br/></Text>

<Text color={TextColor.secondary}>6- Trafik tescil ve ruhsat işlemlerinin resmi bedeli, plaka basım bedeli, ruhsat basım bedeli, ruhsat tescil bedeli ve damga vergisinden ibaret olup, bu
bedeller ve MTV müşteriye aittir. <br/><br/></Text>
<Text color={TextColor.secondary}>7- Trafik tescil ve ruhsat işlemleri müşteri tarafından veya müşterinin talebi halinde müşteriye vekaleten yetkili satıcı veya yetkili satıcının
yetkilendireceği üçüncü şahıslar tarafından yapılabilmektedir. Müşterinin trafik tescil ve ruhsat işlemleri hizmetinin yetkili satıcı veya yetkili satıcının
yetkilendireceği üçüncü şahıslar tarafından yapılmasını istemesi halinde, hizmet bedeli yetkili satıcı ile müşteri arasında belirlenir. Bu nedenle, trafik
tescil ve ruhsat işlemleri hizmet bedeli yetkili satıcıdan yetkili satıcıya değişkenlik gösterebilir. <br/><br/></Text>
<Text color={TextColor.secondary}>8- Trafik sigorta poliçe bedeli yukarıda belirtilmiş olan tavsiye edilen anahtar teslim fiyatına dahil olmayıp, bu bedel müşteri tarafından ayrıca
ödenecektir.<br/><br/></Text>
<Text color={TextColor.secondary}>9- Metalik renk seçeneği opsiyonel olup tavsiye edilen net fiyat Maxi Van modeller için 2.037 TL, Kombi modeller için 1.842 TL’dir. Opsiyonel renk
seçeneğinin araca eklenmesi durumunda, bu fiyat listesinin 3 ve 5 no’lu dipnotlarındaki açıklamalar geçerli olacaktır.<br/><br/></Text>

            </Container>
        )
    }
    
    renderTransporterTexts(){
    return(
        <Container stretchContent={true} padding={topContainerPadding}>
<Text color={TextColor.secondary}><br/> <br/>1- Doğuş Otomotiv üretim, ithalat gibi nedenlere bağlı olarak aracın model, standart ve opsiyonel aksesuarlarında, teknik özelliklerinde ve fiyatlarında önceden haber
vermeksizin değişiklik yapma hakkını saklı tutar.<br/><br/></Text>
<Text color={TextColor.secondary}>2- Bu fiyat listesindeki fiyatların uygulanmaya başladığı tarih 21.11.2020’dir. Tavsiye edilen bu anahtar teslim fiyat listesi yenisi yayınlanana kadar geçerlidir. Listede
belirtilen araçlar stoklarla sınırlıdır. Kesin sipariş verilmesi halinde ifa tarihinde yürürlükte olacak tavsiye edilen fiyat listesindeki fiyatlar geçerli olacaktır. Bu nedenle,
aracın tavsiye edilen anahtar teslim fiyatı değişebilecektir.<br/><br/></Text>
<Text color={TextColor.secondary}>3- Burada belirtilen fiyatlar, standart donanımlı araçlara ait olup, opsiyonel ekipmanlar ve renkler ayrıca fiyatlandırılır.  <br/><br/></Text>
<Text color={TextColor.secondary}>4- Araca ilişkin her türlü vergi (ÖTV, KDV, MTV vb.), trafik tescil ve ruhsat işlemleri resmi bedelleri; resmi tarife değişikliklerine bağlı olarak değişkenlik
gösterebileceğinden, bu değişikliklerden kaynaklanabilecek fiyat farkı / farkları müşteri tarafından karşılanacaktır. Bununla birlikte resmi tarife değişikliği olmaksızın
vergi mevzuatından kaynaklı hesaplama yöntemleri nedeniyle vergi tutarlarında farklar oluşabilecektir.<br/><br/></Text>
<Text color={TextColor.secondary}>5- Menşei: Almanya, Polonya<br/><br/></Text>

<Text color={TextColor.secondary}>6- Trafik tescil ve ruhsat işlemlerinin resmi bedeli, plaka basım bedeli, ruhsat basım bedeli, ruhsat tescil bedeli ve damga vergisinden ibaret olup, bu bedeller ve MTV
müşteriye aittir.<br/><br/></Text>
<Text color={TextColor.secondary}>7- Trafik tescil ve ruhsat işlemleri müşteri tarafından veya müşterinin talebi halinde müşteriye vekaleten yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü
şahıslar tarafından yapılabilmektedir. Müşterinin trafik tescil ve ruhsat işlemleri hizmetinin yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü şahıslar tarafından
yapılmasını istemesi halinde, hizmet bedeli yetkili satıcı ile müşteri arasında belirlenir. Bu nedenle, trafik tescil ve ruhsat işlemleri hizmet bedeli yetkili satıcıdan yetkili
satıcıya değişkenlik gösterebilir.<br/><br/></Text>
<Text color={TextColor.secondary}>8- Trafik sigorta poliçe bedeli yukarıda belirtilmiş olan tavsiye edilen anahtar teslim fiyatına dahil olmayıp, bu bedel müşteri tarafından ayrıca ödenecektir.<br/><br/></Text>
<Text color={TextColor.secondary}>9- Metalik renk seçeneği opsiyonel olup tavsiye edilen net fiyatı Panel Van ve Pikap için 3.056TL, Camlı Van ve City Van için 2.763TL’dir. Opsiyonel renk seçeneğinin
araca eklenmesi durumunda, bu fiyat listesinin 3 ve 5 no’lu dipnotlarındaki açıklamalar geçerli olacaktır<br/><br/></Text>

</Container>

    )
}

renderCaravelleTexts(){
    return(
        <Container stretchContent={true} padding={topContainerPadding}>
<Text color={TextColor.secondary}><br/> <br/>1- Doğuş Otomotiv üretim, ithalat gibi nedenlere bağlı olarak aracın model, standart ve opsiyonel aksesuarlarında, teknik özelliklerinde ve fiyatlarında önceden haber
vermeksizin değişiklik yapma hakkını saklı tutar.<br/><br/></Text>
<Text color={TextColor.secondary}>2- Bu fiyat listesindeki fiyatların uygulanmaya başladığı tarih 21.11.2020’dir.Tavsiye edilen bu anahtar teslim fiyat listesi yenisi yayınlanana kadar geçerlidir. Listede
belirtilen araçlar stoklarla sınırlıdır. Kesin sipariş verilmesi halinde ifa tarihinde yürürlükte olacak tavsiye edilen fiyat listesindeki fiyatlar geçerli olacaktır. Bu nedenle,
aracın tavsiye edilen anahtar teslim fiyatı değişebilecektir.<br/><br/></Text>
<Text color={TextColor.secondary}>3- Burada belirtilen fiyatlar, standart donanımlı araçlara ait olup, opsiyonel ekipmanlar ve renkler ayrıca fiyatlandırılır. <br/><br/></Text>
<Text color={TextColor.secondary}>4- Araca ilişkin her türlü vergi (ÖTV, KDV, MTV vb.), trafik tescil ve ruhsat işlemleri resmi bedelleri; resmi tarife değişikliklerine bağlı olarak değişkenlik
gösterebileceğinden, bu değişikliklerden kaynaklanabilecek fiyat farkı / farkları müşteri tarafından karşılanacaktır. Bununla birlikte resmi tarife değişikliği olmaksızın
vergi mevzuatından kaynaklı hesaplama yöntemleri nedeniyle vergi tutarlarında farklar oluşabilecektir. <br/><br/></Text>
<Text color={TextColor.secondary}>5- Menşei: Almanya, Polonya<br/><br/></Text>

<Text color={TextColor.secondary}>6- Trafik tescil ve ruhsat işlemlerinin resmi bedeli, plaka basım bedeli, ruhsat basım bedeli, ruhsat tescil bedeli ve damga vergisinden ibaret olup, bu bedeller ve MTV
müşteriye aittir. <br/><br/></Text>
<Text color={TextColor.secondary}>7- Trafik tescil ve ruhsat işlemleri müşteri tarafından veya müşterinin talebi halinde müşteriye vekaleten yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü
şahıslar tarafından yapılabilmektedir. Müşterinin trafik tescil ve ruhsat işlemleri hizmetinin yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü şahıslar tarafından
yapılmasını istemesi halinde, hizmet bedeli yetkili satıcı ile müşteri arasında belirlenir. Bu nedenle, trafik tescil ve ruhsat işlemleri hizmet bedeli yetkili satıcıdan yetkili
satıcıya değişkenlik gösterebilir. <br/><br/></Text>
<Text color={TextColor.secondary}>8- Trafik sigorta poliçe bedeli yukarıda belirtilmiş olan tavsiye edilen anahtar teslim fiyatına dahil olmayıp, bu bedel müşteri tarafından ayrıca ödenecektir.<br/><br/></Text>

        </Container>

    )
}

renderCrafterTexts(){
    return(
        <Container stretchContent={true} padding={topContainerPadding}>
<Text color={TextColor.secondary}><br/> <br/>1- Doğuş Otomotiv üretim, ithalat gibi nedenlere bağlı olarak aracın model, standart ve opsiyonel aksesuarlarında, teknik özelliklerinde ve fiyatlarında önceden haber vermeksizin
değişiklik yapma hakkını saklı tutar<br/><br/></Text>
<Text color={TextColor.secondary}>2- Bu fiyat listesindeki fiyatların uygulanmaya başladığı tarih 21.11.2020’dir. Tavsiye edilen bu anahtar teslim fiyat listesi yenisi yayınlanana kadar geçerlidir. Listede belirtilen araçlar
stoklarla sınırlıdır. Kesin sipariş verilmesi halinde ifa tarihinde yürürlükte olacak tavsiye edilen fiyat listesindeki fiyatlar geçerli olacaktır. Bu nedenle, aracın tavsiye edilen anahtar teslim
fiyatı değişebilecektir <br/><br/></Text>
<Text color={TextColor.secondary}>3- Burada belirtilen fiyatlar, standart donanımlı araçlara ait olup, opsiyonel ekipmanlar ve renkler ayrıca fiyatlandırılır. <br/><br/></Text>
<Text color={TextColor.secondary}>4- Araca ilişkin her türlü vergi (ÖTV, KDV, MTV vb.), trafik tescil ve ruhsat işlemleri resmi bedelleri; resmi tarife değişikliklerine bağlı olarak değişkenlik gösterebileceğinden, bu
değişikliklerden kaynaklanabilecek fiyat farkı / farkları müşteri tarafından karşılanacaktır. Bununla birlikte resmi tarife değişikliği olmaksızın vergi mevzuatından kaynaklı hesaplama
yöntemleri nedeniyle vergi tutarlarında farklar oluşabilecektir<br/><br/></Text>
<Text color={TextColor.secondary}>5- Menşei: Polonya<br/><br/></Text>
<Text color={TextColor.secondary}>6- Trafik tescil ve ruhsat işlemlerinin resmi bedeli, plaka basım bedeli, ruhsat basım bedeli, ruhsat tescil bedeli ve damga vergisinden ibaret olup, bu bedeller ve MTV müşteriye aittir. <br/><br/></Text>
<Text color={TextColor.secondary}>7- Trafik tescil ve ruhsat işlemleri müşteri tarafından veya müşterinin talebi halinde müşteriye vekaleten yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü şahıslar tarafından
yapılabilmektedir. Müşterinin trafik tescil ve ruhsat işlemleri hizmetinin yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü şahıslar tarafından yapılmasını istemesi halinde, hizmet
bedeli yetkili satıcı ile müşteri arasında belirlenir. Bu nedenle, trafik tescil ve ruhsat işlemleri hizmet bedeli yetkili satıcıdan yetkili satıcıya değişkenlik gösterebilir.<br/><br/></Text>
<Text color={TextColor.secondary}>8- Trafik sigorta poliçe bedeli yukarıda belirtilmiş olan tavsiye edilen anahtar teslim fiyatına dahil olmayıp, bu bedel müşteri tarafından ayrıca ödenecektir.<br/><br/></Text>
<Text color={TextColor.secondary}>9- Metalik renk seçeneği opsiyonel olup tavsiye edilen net fiyatı 6.356 TL’dir. Opsiyonel renk seçeneğinin araca eklenmesi durumunda, bu fiyat listesinin 3 ve 5 no’lu dipnotlarındaki
açıklamalar geçerli olacaktır.<br/><br/></Text> 

</Container>
    )
}

renderAmarokTexts(){
    return(
        <Container stretchContent={true} padding={topContainerPadding}>
        <Text color={TextColor.secondary}><br/> <br/>1- Doğuş Otomotiv üretim, ithalat gibi nedenlere bağlı olarak aracın model, standart ve opsiyonel aksesuarlarında, teknik özelliklerinde ve fiyatlarında
önceden haber vermeksizin değişiklik yapma hakkını saklı tutar.<br/><br/></Text>
        <Text color={TextColor.secondary}>2- Bu fiyat listesindeki fiyatların uygulanmaya başladığı tarih 21.11.2020’dir. Tavsiye edilen bu anahtar teslim fiyat listesi yenisi yayınlanana kadar
geçerlidir. Listede belirtilen araçlar stoklarla sınırlıdır. Kesin sipariş verilmesi halinde ifa tarihinde yürürlükte olacak tavsiye edilen fiyat listesindeki
fiyatlar geçerli olacaktır. Bu nedenle, aracın tavsiye edilen anahtar teslim fiyatı değişebilecektir.<br/><br/></Text>
        <Text color={TextColor.secondary}>3- Burada belirtilen fiyatlar, standart donanımlı araçlara ait olup, opsiyonel ekipmanlar ve renkler ayrıca fiyatlandırılır. <br/><br/></Text>
        <Text color={TextColor.secondary}>4- Araca ilişkin her türlü vergi (ÖTV, KDV, MTV vb.), trafik tescil ve ruhsat işlemleri resmi bedelleri; resmi tarife değişikliklerine bağlı olarak değişkenlik
gösterebileceğinden, bu değişikliklerden kaynaklanabilecek fiyat farkı / farkları müşteri tarafından karşılanacaktır. Bununla birlikte resmi tarife değişikliği
olmaksızın vergi mevzuatından kaynaklı hesaplama yöntemleri nedeniyle vergi tutarlarında farklar oluşabilecektir.  <br/><br/></Text>
<Text color={TextColor.secondary}>5- Menşei: Almanya<br/><br/></Text>

        <Text color={TextColor.secondary}>6- Trafik tescil ve ruhsat işlemlerinin resmi bedeli, plaka basım bedeli, ruhsat basım bedeli, ruhsat tescil bedeli ve damga vergisinden ibaret olup, bu
bedeller ve MTV müşteriye aittir. <br/><br/></Text>
        <Text color={TextColor.secondary}>7- Trafik tescil ve ruhsat işlemleri müşteri tarafından veya müşterinin talebi halinde müşteriye vekaleten yetkili satıcı veya yetkili satıcının
yetkilendireceği üçüncü şahıslar tarafından yapılabilmektedir. Müşterinin trafik tescil ve ruhsat işlemleri hizmetinin yetkili satıcı veya yetkili satıcının
yetkilendireceği üçüncü şahıslar tarafından yapılmasını istemesi halinde, hizmet bedeli yetkili satıcı ile müşteri arasında belirlenir. Bu nedenle, trafik
tescil ve ruhsat işlemleri hizmet bedeli yetkili satıcıdan yetkili satıcıya değişkenlik gösterebilir.<br/><br/></Text>
        <Text color={TextColor.secondary}>8- Trafik sigorta poliçe bedeli yukarıda belirtilmiş olan tavsiye edilen anahtar teslim fiyatına dahil olmayıp, bu bedel müşteri tarafından ayrıca
ödenecektir.<br/><br/></Text>
        <Text color={TextColor.secondary}>9- Metalik renk seçeneği opsiyonel olup tavsiye edilen net fiyatı 2.241 TL’dir. Opsiyonel renk seçeneğinin araca eklenmesi durumunda, bu fiyat listesinin
3 ve 5 no’lu dipnotlarındaki açıklamalar geçerli olacaktır.<br/><br/></Text>

</Container>
    )

}
}
const carContainerPadding = (index, datasetLength) => ({
    left: {
        [Breakpoints.default]: index === 0 ? ContainerPadding.grid003 : ContainerPadding.dynamic0040,
        [Breakpoints.b960]: ContainerPadding.dynamic0020
    },
    right: {
        [Breakpoints.default]: index === datasetLength - 1 ? ContainerPadding.grid003 : ContainerPadding.dynamic0040,
        [Breakpoints.b960]: ContainerPadding.dynamic0020
    },
})

const fixedWidthContainerAppearance = {
    [Breakpoints.default]: 4,
    [Breakpoints.b560]: 4,
    [Breakpoints.tablet]: 2,
    [Breakpoints.b1280]: 2,
    [Breakpoints.b1920]: 1
}

const dummyArray = [
    {
        name: 'Caddy',
        img: caddy,
        activeImage: caddyActive
    },
    {
        name: 'Transporter',
        img: transporter,
        activeImage: transporterActive
    },
    {
        name: 'Caravelle',
        img: transporter,
        activeImage: transporterActive
    },
    {
        name: 'Amarok',
        img: amarok,
        activeImage: amarokActive
    },
    {
        name: 'Crafter',
        img: crafter,
        activeImage: crafterActive
    }
]

const topContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b1600]: ContainerPadding.grid004
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b1600]: ContainerPadding.grid004
    }
}

const globalPadding = {
    [Breakpoints.b1920]: ContainerPadding.grid007,
    [Breakpoints.b1600]: ContainerPadding.grid006,
    [Breakpoints.b1280]: ContainerPadding.grid005,
    [Breakpoints.b960]: ContainerPadding.grid004,
    [Breakpoints.default]: ContainerPadding.grid002
}

const padding4Dimensions = {
    left: globalPadding,
    right: globalPadding,
    bottom: ContainerPadding.dynamic0100
}



export default HorizontalCarList;